import {
    BS_IMAGE_CAPTION_TYPE,
    BS_IMAGE_FIGURE_TYPE,
} from './constants';
import { findCaptionInFigure, resolveBsImageFigure } from './utils';

export function coerceMediaFieldToString(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'object' && typeof value.raw === 'string') {
        return value.raw.trim();
    }
    if (typeof value === 'object') {
        for (const entry of Object.values(value)) {
            if (typeof entry === 'string' && entry.trim()) {
                return entry.trim();
            }
        }
    }
    return '';
}

export function extractMediaDescription(media) {
    if (!media) return '';
    return media?.description || '';
}

export function setFigureCaptionFromDescription(figure, description) {
    if (!figure?.get || figure.get('type') !== BS_IMAGE_FIGURE_TYPE) return;

    const text = coerceMediaFieldToString(description);
    const existing = findCaptionInFigure(figure);

    if (!text) {
        existing?.remove();
        return;
    }

    const caption = existing || figure.components().add({ type: BS_IMAGE_CAPTION_TYPE });
    caption.set('content', text);
    caption.removeClass('sio-image-caption--hidden');
    caption.removeClass('sio-image-caption--editing');
}

export function getMediaItemSrc(item) {
    if (!item) return '';
    const file = item.file;
    if (file?.previewUrl) {
        return file.previewUrl
            .replace('$width', '1500')
            .replace('$height', '-');
    }
    return file?.downloadUrl || item.url || item.src || '';
}


export function applyBsImageMediaResult({ imageTarget, figure, result }) {
    if (!result?.url || !imageTarget) return;
    imageTarget.set('src', getMediaItemSrc(result));
    imageTarget.addAttributes({
        src: result.url,
        alt: result.alt ?? '',
        title: result.title ?? '',
    });
    imageTarget.trigger('change:attributes');
    imageTarget.removeClass('gjs-plh-image');

    const targetFigure = figure || resolveBsImageFigure(imageTarget);
    if (targetFigure) {
        setFigureCaptionFromDescription(targetFigure, extractMediaDescription(result));
    }
}
